export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-array/src/threshold/sturges.js
// module id = Krhj
// module chunks = 0